import Typography from "@portal/components/atoms/v2/typography";
import { ButtonOptionSelector } from "@portal/components/atoms/buttonOptionSelector";
import { OnPeriodDayNumberClick } from "../../handlers";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IPeriodDayOptionsProps } from "../types";

export const PeriodDayOptions = ({
  isDefaultLanguage,
  selectedPeriodDayNumber,
  header,
  setSelectedPeriodDayNumber,
  dispatch,
}: IPeriodDayOptionsProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const dates = [texts.PAGE_16_DATE_A, texts.PAGE_16_DATE_B, texts.PAGE_16_DATE_C, texts.PAGE_16_DATE_D];

  const handleChange = (i: number) => {
    OnPeriodDayNumberClick(i, setSelectedPeriodDayNumber, dispatch);
  };

  return (
    <>
      <div className="flex mt-2">
        <Typography variant="Bold">{header}</Typography>
      </div>
      <div className="flex mb-2">
        <ButtonOptionSelector
          options={dates.map((o, i) => (
            <Typography key={i}>{o}</Typography>
          ))}
          selectedItem={selectedPeriodDayNumber}
          handleChange={handleChange}
        />
      </div>
    </>
  );
};
